import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider';

(function () {

  if (
    !document.body.classList.contains('plan-page')
    || !document.querySelector('.plan-slider')
  ) return this;

  var big_slider = tns({
  	loop: false,
  	container: '.plan-slider__main',
  	navContainer: '.plan-slider__thumb',
  	items: 1,
    navAsThumbnails: true,
  	mouseDrag: false,
    controls: false,
  });

  var small_slider = tns({
    loop: false,
    container: '.plan-slider__thumb',
    items: 1,
    mouseDrag: false,
    nav: false,
    controls: false,
    axis: "vertical"
  });

})();
